<template>
  <b-container>
    <b-row>
      <b-col cols="8">
        <b-form-group
          :id="`asset-url-group-${refId}`"
          :label="label"
          :label-for="`asset-url-input-${refId}`">
          <b-input-group>
            <b-form-input
              :id="`asset-url-input-${refId}`"
              :ref="`input-${refId}`"
              v-model="imageURL"
              :disabled="!canSponsorshipConfigEdit"
              :state="urlState(imageURL)"
              type="url"
              :required="required"
              trim />
            <b-input-group-append>
              <b-btn
                variant="outline-primary"
                @click.prevent="$refs[refId].show()">
                <i class="fas fa-plus" />
              </b-btn>
            </b-input-group-append>
            <b-form-valid-feedback
              v-if="!imageURL"
              force-show>
              Sponsorship Image is empty and will not show on device
            </b-form-valid-feedback>
            <b-form-invalid-feedback>
              Enter a valid URL
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <label v-if="isPdf(imageURL) || isImage(imageURL)">Preview</label>
        <div
          v-if="isPdf(imageURL)"
          style="width:50%">
          <b-progress
            v-if="assetPreviewLoadedRatio > 0 && assetPreviewLoadedRatio < 1"
            :value="assetPreviewLoadedRatio * 100"
            show-value
            show-progress
            animated />
          <pdf
            :src="imageURL"
            @error="onPdfError"
            @progress="assetPreviewLoadedRatio = $event" />
        </div>
        <b-img
          v-else-if="isImage(imageURL)"
          :src="imageURL"
          fluid />
      </b-col>
    </b-row>
    <b-modal
      :ref="refId"
      hide-header
      hide-footer
      size="lg">
      <asset-upload
        post-action="/api/configuration/v1/sponsorship/assets"
        :allow-multiple-uploads="false"
        :hide-additional-options="true"
        @asset-url-selected="onAssetSelect"
        @cancel="$refs[refId].hide()" />
    </b-modal>
  </b-container>
</template>

<script>
  import AssetUpload from "../AssetUpload"
  import pdf from 'vue-pdf'

  export default {
    name: "ImageUploadForm",
    components: {AssetUpload, pdf},
    props: {
      value: {
        type: String,
        required: false,
        default: null,
      },
      canSponsorshipConfigEdit: {
        type: Boolean,
        required: true,
      },
      refId: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        assetPreviewLoadedRatio: 0,
      }
    },
    computed: {
      imageURL: {
        get: function() {
          return this.value
        },
        set: function (value) {
          this.$emit("input", value)
        },
      },
    },
    methods: {
      isValidUrl(url) {
        const valid = /^(http|https):\/\/[^ "]+$/i.test(url)
        if (!valid) {
          this.$emit("on-error", valid)
        }
        return valid
      },
      isPdf(file) {
        return file != null && file.split('.').pop() === 'pdf'
      },
      isImage(file) {
        return file != null && /.(jpg|jpeg|png|gif)$/i.test(file)
      },
      urlState(value) {
        if (this.required) {
          return this.isValidUrl(value)
        }
        return this.imageURL ? this.isValidUrl(value) : null
      },
      onAssetSelect(url) {
        this.$refs[this.refId].hide()
        console.log(`New asset url: ${url}`)

        if (url) {
          this.$emit("input", url)
        } else {
          console.warn('Ignoring invalid asset selection')
        }
      },
      onPdfError(error) {
        console.error('Unable to load asset preview pdf', error)
      },
    },
  }
</script>

<style scoped>

</style>
